import BlockObserver from "./BlockObserver";
import {lazyBackground, lazyLoadImage} from "../utils/utils";

export default class TheProcess {
    init(block) {
        this.timelineButtons    	= block.querySelectorAll('[data-button]');
        this.timelineItems      	= block.querySelectorAll('[data-item]');
        this.timelineBar        	= block.querySelector('.timeline__bar span');
        this.timelineBarContainer 	= block.querySelector('.timeline__bar');
        this.totalItems         	= this.timelineItems.length;
		let isVisible 			= null;
		let hasShown		= false;


        this.timelineButtons && this.timelineButtons.forEach((timelineButton) => {
            timelineButton.addEventListener('click', (event) => {
                this.changeStep(timelineButton, this.timelineButtons, this.timelineItems);
            });
        });

		this.getTallest(block, this.timelineItems);

		const callBack = (entries) => {
			isVisible = entries[0].isIntersecting;
			if(isVisible) {
				if(hasShown === false) {
					this.automateProcess(block, this.timelineItems, this.timelineButtons, this.timelineBarContainer);
					hasShown = true;
				}
			}
		};

		const observer = new IntersectionObserver(callBack, {
			root: null,
			rootMargin: '-200px 0px 0px 0px',
			threshold: 0,
		});

		observer.observe(document.querySelector('.b-the-process'));
    }

    changeStep(clickedButton, allButtons, allItems) {
        allButtons.forEach((button) => {
            button.classList.remove('active');
            if(button.getAttribute("data-button") === clickedButton.dataset.button) {
                button.classList.add('active');

                if (window.innerWidth < 1024) {
					if(clickedButton.dataset.button === String(allItems.length)) {
						this.timelineBar.style.width = this.timelineBarContainer.offsetWidth + 'px';
					} else {
						this.timelineBar.style.width = (clickedButton.offsetLeft + (clickedButton.offsetWidth / 2)) + 'px';
					}
                } else {
					if(clickedButton.dataset.button === String(allItems.length)) {
						this.timelineBar.style.height = this.timelineBarContainer.offsetHeight + 'px';
					} else {
						this.timelineBar.style.height = (clickedButton.offsetTop + (clickedButton.offsetHeight / 2) + 4) + 'px';
					}
                }
            }
        });

        allItems.forEach((item) => {
            item.classList.remove('active');
            if(item.getAttribute("data-item") === clickedButton.dataset.button) {
                item.classList.add('active');
            }
        });
    }

	getTallest(block, elements) {
		let maxHeight = 0;
		for (let i = 0; i < elements.length; i++) {
			if (elements[i].offsetHeight > maxHeight) {
				maxHeight = elements[i].offsetHeight;
			}
		}

		elements.forEach((element) => {
			element.style.height = maxHeight+'px';
		});

		block.querySelector('.b-the-process__process-items').style.height = maxHeight+'px';
	}

	automateProcess(block, timelineItems, timelineButtons, timelineBarContainer) {
		let count 					= 0;
		let scrollPosition 		= 0;
		let activeItem				= 0;
		let totalItems						= timelineItems.length;

		block.querySelector('.timeline__items').style.pointerEvents = 'none';

		changeButton(timelineButtons, 1);
		changeItem(timelineItems, 1);

		let processTimer = setInterval(() => {
			count++;
			scrollPosition = count;

			// Move the progress bar the correct way depending on screen size
			if(window.innerWidth < 1024) {
				this.timelineBar.style.width = scrollPosition+'px';
				// If current counter matches position of a button, trigger transition
				timelineButtons.forEach(function(button) {
					if(scrollPosition === Math.round((button.offsetLeft + (button.offsetWidth / 2)))) {
						activeItem++;

						changeButton(timelineButtons, activeItem);
						changeItem(timelineItems, activeItem);
					}
				});

				// When reaching the end, force set everything to the end and stop the counter
				if(count >= timelineBarContainer.offsetWidth) {
					scrollPosition 	= timelineBarContainer.offsetWidth;
					count 			= 0;
					activeItem 		= totalItems;
					clearInterval(processTimer);
					block.querySelector('.timeline__items').style.pointerEvents = 'initial';
				}
			} else {
				this.timelineBar.style.height = scrollPosition+'px';

				// If current counter matches position of a button, trigger transition
				timelineButtons.forEach(function(button) {
					if(scrollPosition === Math.round((button.offsetTop + (button.offsetHeight / 2) + 4))) {
						activeItem++;

						changeButton(timelineButtons, activeItem);
						changeItem(timelineItems, activeItem);
					}
				});

				// When reaching the end, force set everything to the end and stop the counter
				if(count >= timelineBarContainer.offsetHeight) {
					scrollPosition 	= timelineBarContainer.offsetHeight;
					count 			= 0;
					activeItem 		= totalItems;
					clearInterval(processTimer);
					block.querySelector('.timeline__items').style.pointerEvents = 'initial';
				}
			}
		}, 25);

		function changeButton(buttons, activeButton) {
			buttons.forEach((button) => {
				button.classList.remove('active');
				if(button.getAttribute("data-button") == activeButton) {
					button.classList.add('active');
				}
			});
		}

		function changeItem(items, activeItem) {
			items.forEach((item) => {
				item.classList.remove('active');
				if(item.getAttribute("data-item") == activeItem) {
					item.classList.add('active');
				}
			});
		}
	}
}